export const HEADER_DATA = {
  // Default/fallback data for Revolution Mortgage
  companyName: 'Revolution Mortgage',
  companyNmls: '#1686046',
  // Default loan officer (can be overridden)
  loanOfficer: 'LaTanya Settles',
  nmls: '#273463',
};
